import React, { useState, useCallback, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";

import {
    Wrapper,
    Partner,
    PartnerCover,
    WrapCover,
    Cover,
    PartnerDetails,
    WrapperLogo,
    Logo,
    Title,
    Content,
    PartnerProducts,
    PartnerProduct,
    ProductImage,
    Button
} from "./styles";
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';

import OfferService from '../../../../services/Offer';

import loadImage from '../../../../utils/LoadImage';
import handleURLParams from '../../../../utils/handleURLParams';

import PartnerLogoPlaceholder from "../../../../assets/images/placeholders/partner-logo-160x130.png";
import PartnerBannerPlaceholder from "../../../../assets/images/placeholders/partner-banner-760x346.png";
import ProductPlaceholder from "../../../../assets/images/placeholders/product-458x406.png";

function PartnerBox({ title, cover, partnerLogo, partnerId, partnerUrl }) {
    const [productsPreview, setProductsPreview] = useState([]);
    const history = useHistory();
    const location = useLocation();

    const handleOfferSearch = ({ product, type }) => {
        handleURLParams({
            listOfKeyValues: [
                { key: 'productId', value: product },
                { key: 'limit', value: 8 }
            ],
            location: location,
            history: history
        });
        return history.push({ pathname: type === 'desconto' || type === 'divulgacao' ? '/oferta' : '/resgatar', search: history.location.search });
    }

    const handlePartnerSearch = ({ partner }) => {
        handleURLParams({
            listOfKeyValues: [
                { key: 'partnerId', value: partner }
            ],
            location: location,
            history: history
        })

        return history.push({ pathname: '/parceiro', search: history.location.search });
    }

    const handleProductsPreview = useCallback(() => {
        const offerService = new OfferService();

        offerService.listOffUs({ partner: partnerId }).then((response) => {
            setProductsPreview(response.data.payload);
        });

    }, [partnerId]);

    useEffect(() => {
        handleProductsPreview();
    }, [handleProductsPreview])

    return (
        <Wrapper>
            <Partner>
                <PartnerCover>
                    {partnerUrl ?
                        (<a href={partnerUrl ? partnerUrl : '#!'} rel="noopener noreferrer" target="_blank">
                            <WrapCover>
                                <Cover src={cover} alt={title} />
                            </WrapCover>
                            <PartnerDetails>
                                <WrapperLogo>
                                    <Logo
                                        onError={(e) => e.target.src = PartnerLogoPlaceholder}
                                        src={partnerLogo}
                                        imageAlt={title}
                                    />
                                </WrapperLogo>
                                <Title>{title ? title : "..."}</Title>
                            </PartnerDetails>
                        </a>) :
                        (<>
                            <WrapCover>
                                <Cover
                                    onError={(e) => e.target.src = PartnerBannerPlaceholder}
                                    src={cover}
                                    alt={title}
                                />
                            </WrapCover>
                            <PartnerDetails>
                                <WrapperLogo>
                                    <Logo
                                        onError={(e) => e.target.src = PartnerLogoPlaceholder}
                                        src={partnerLogo}
                                        imageAlt={title}
                                    />
                                </WrapperLogo>
                                <Title>{title ? title : "..."}</Title>
                            </PartnerDetails>
                        </>)}
                </PartnerCover>

                <Content>

                    {productsPreview && productsPreview.length > 0 && (
                        <PartnerProducts>
                            {productsPreview.slice(0, 3).map(({ _id, titulo, imagens, tipo_oferta }) => (
                                <PartnerProduct key={`${_id}`}>
                                    <a href='#!' onClick={() => handleOfferSearch({ product: _id, type: tipo_oferta })}>
                                        <ProductImage
                                            onError={(e) => e.target.src = ProductPlaceholder}
                                            src={loadImage({ imageCode: imagens[0] })}
                                            alt={titulo}
                                        />
                                    </a>
                                </PartnerProduct>

                            ))}
                        </PartnerProducts>
                    )}

                    <Button>
                        <a href="#!" onClick={() => handlePartnerSearch({ partner: partnerId })}>
                            Ver ofertas
                            <Icon icon={["far", "chevron-right"]} />
                        </a>
                    </Button>


                </Content>
            </Partner>
        </Wrapper>
    )
}

export default PartnerBox;